import React from 'react';
import { Timer as HeaderTimer } from '@pegasus/ui-headers';
import { useTimer, Cart } from '@pegasus/cart';

export interface Props {
    cart?: Cart;

    onCartExpiresFirstWarning: () => void;
    onCartExpiresSecondWarning: () => void;
    onCartExpiresLastWarning: () => void;
    onCartExpired: () => void;
}

export const Timer = ({ cart, ...options }: Props) => {
    const { counter } = useTimer(cart, options);

    return <HeaderTimer timeLeft={counter} />;
};
